import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { Protocol } from '@lib/core/models/protocol.interface';

@Injectable({
  providedIn: 'root',
})
export class ProtocolService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrl: string;

  constructor(@Inject('API_URL') apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  getProtocolById(id: string) {
    return this.http.get<Protocol>(`${this.apiUrl}/protocols/${id}`);
  }
}
